import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-worn-bloc",
  templateUrl: "./worn-bloc.component.html",
  styleUrls: ["./worn-bloc.component.scss"],
  standalone: false,
})
export class WornBlocComponent implements OnInit {
  @Input() Text: string = "";
  @Input() trype: string = "warn";
  constructor() {}

  ngOnInit() {}
}
